import v4 from 'uuid/v4'

const newMedicines = [
  {
    code: v4(),
    name: 'Engerix B',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '66071002'
    ]
  },
  {
    code: v4(),
    name: 'Twinrix (Adulto)',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '66071002',
      '40468003'
    ]
  },
  {
    code: v4(),
    name: 'Twinrix (Pediátrico)',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '66071002',
      '40468003'
    ]
  },
  {
    code: v4(),
    name: 'Infanrix - Hib',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '709410003',
      '397428000',
      '76902006',
      '27836007'
    ]
  },
  {
    code: v4(),
    name: 'Pentavac',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '709410003',
      '397428000',
      '76902006',
      '27836007',
      '398102009'
    ]
  },
  {
    code: v4(),
    name: 'PENTAXIM',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '709410003',
      '27836007',
      '398102009'
    ]
  },
  {
    code: v4(),
    name: 'Hiberix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '709410003'
    ]
  },
  {
    code: v4(),
    name: 'Infanrix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '397428000',
      '76902006',
      '27836007'
    ]
  },
  {
    code: v4(),
    name: 'Boostrix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '397428000',
      '76902006',
      '27836007'
    ]
  },
  {
    code: v4(),
    name: 'D.T Vax Adulto',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '397428000',
      '76902006'
    ]
  },
  {
    code: v4(),
    name: 'Infanrix Tetra',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '397428000',
      '76902006',
      '27836007',
      '398102009'
    ]
  },
  {
    code: v4(),
    name: 'Tetravac',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '397428000',
      '76902006',
      '27836007',
      '398102009'
    ]
  },
  {
    code: v4(),
    name: 'Imovax Polio',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '398102009'
    ]
  },
  {
    code: v4(),
    name: 'Pneumo 23',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '9861002'
    ]
  },
  {
    code: v4(),
    name: 'Prevenar 13',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '9861002'
    ]
  },
  {
    code: v4(),
    name: 'Synflorix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '9861002'
    ]
  },
  {
    code: v4(),
    name: 'Bexsero',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '23511006'
    ]
  },
  {
    code: v4(),
    name: 'Menjugate',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '23511006'
    ]
  },
  {
    code: v4(),
    name: 'Menjugate Kit',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '23511006'
    ]
  },
  {
    code: v4(),
    name: 'Menveo',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '23511006'
    ]
  },
  {
    code: v4(),
    name: 'NeisVac-C',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '23511006'
    ]
  },
  {
    code: v4(),
    name: 'Nimenrix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '23511006'
    ]
  },
  {
    code: v4(),
    name: 'M-M-RVAXPRO',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '14189004',
      '240526004',
      '36653000'
    ]
  },
  {
    code: v4(),
    name: 'Cervarix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '371973000'
    ]
  },
  {
    code: v4(),
    name: 'Gardasil',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '371973000'
    ]
  },
  {
    code: v4(),
    name: 'Antitetânica',
    type: 'immunoglobulin',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '76902006'
    ]
  },
  {
    code: v4(),
    name: 'Antidiftérica',
    type: 'immunoglobulin',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '397428000'
    ]
  },
  {
    code: v4(),
    name: 'Ixiaro',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '52947006'
    ]
  },
  {
    code: v4(),
    name: 'BCG',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '56717001'
    ]
  },
  {
    code: v4(),
    name: 'Dukoral',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '63650001'
    ]
  },
  {
    code: v4(),
    name: 'Stamaril',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '16541001'
    ]
  },
  {
    code: v4(),
    name: 'Typherix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '4834000'
    ]
  },
  {
    code: v4(),
    name: 'Typhix Vi',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '4834000'
    ]
  },
  {
    code: v4(),
    name: 'Havrix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '40468003'
    ]
  },
  {
    code: v4(),
    name: 'Vaqta',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '40468003'
    ]
  },
  {
    code: v4(),
    name: 'Rabipur',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '14168008'
    ]
  },
  {
    code: v4(),
    name: 'Rotarix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '64694002'
    ]
  },
  {
    code: v4(),
    name: 'RotaTeq',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '64694002'
    ]
  },
  {
    code: v4(),
    name: 'VarilRix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '38907003'
    ]
  },
  {
    code: v4(),
    name: 'Varivax',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '38907003'
    ]
  },
  {
    code: v4(),
    name: 'Fluarix',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '6142004'
    ]
  },
  {
    code: v4(),
    name: 'Influvac',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '6142004'
    ]
  },
  {
    code: v4(),
    name: 'Istivac',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '6142004'
    ]
  },
  {
    code: v4(),
    name: 'Vaxigrip',
    type: 'vaccine',
    lots: ['ZXVASD', '49GKR3', 'OFNJ43'],
    targetDiseases: [
      '6142004'
    ]
  }
]

export { newMedicines }
//
// const structuredData = []
//
// data.forEach(element => structuredData.push(new Medicine(element.code, element.name, element.type, element.lots, element.pathologies)))
// export default structuredData
